enum ActionTypes {
  SET_NETWORK_ONLINE = 'SET_NETWORK_ONLINE',
  SET_NETWORK_OFFLINE = 'SET_NETWORK_OFFLINE',
  SET_NETWORK_READY = 'SET_NETWORK_READY'
}

export default ActionTypes;
